/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsMachineDesign
 */
export interface EodMelcoEodModelsMachineDesign {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsMachineDesign
     */
    device_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsMachineDesign
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsMachineDesign
     */
    file_signature?: string | null;
}

export function EodMelcoEodModelsMachineDesignFromJSON(json: any): EodMelcoEodModelsMachineDesign {
    return EodMelcoEodModelsMachineDesignFromJSONTyped(json, false);
}

export function EodMelcoEodModelsMachineDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsMachineDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'device_id': !exists(json, 'device_id') ? undefined : json['device_id'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'file_signature': !exists(json, 'file_signature') ? undefined : json['file_signature'],
    };
}

export function EodMelcoEodModelsMachineDesignToJSON(value?: EodMelcoEodModelsMachineDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'device_id': value.device_id,
        'file_name': value.file_name,
        'file_signature': value.file_signature,
    };
}


